import styled from "styled-components";

export const ContentMainFlagsStyled = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentFlagsStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  svg {
    width: 60px;
    height: 30px;
  }
`;